const menuButton = document.getElementById("menuButton");
const menuContactWrap = document.getElementById("js-menu_layer"); // menu_contact_wrapを取得
const logoImg = document.querySelector("#branding .js-site-logo");
let isMenuOpened = false;

// 事前にロゴの切替先を取得
const defaultLogo = logoImg ? logoImg.getAttribute("data-logo-default") : null;
const whiteLogo = logoImg ? logoImg.getAttribute("data-logo-white") : null;

function toggleMenu() {
  isMenuOpened = !isMenuOpened;
  if (isMenuOpened) {
    // メニューを開いた時の処理
    menuButton.classList.add("is-opened");
    menuContactWrap.classList.add("is-opened"); // menu_contact_wrapにクラスを追加

    // ロゴを白バージョンへ切替
    if (logoImg && whiteLogo) {
      logoImg.src = whiteLogo;
    }
  } else {
    // メニューを閉じた時の処理
    menuButton.classList.remove("is-opened");
    menuContactWrap.classList.remove("is-opened"); // menu_contact_wrapのクラスを削除

    // ロゴをデフォルトへ戻す
    if (logoImg && defaultLogo) {
      logoImg.src = defaultLogo;
    }
  }

  // アクセシビリティ: 開閉状態を明示
  if (menuButton) {
    menuButton.setAttribute("aria-expanded", String(isMenuOpened));
  }
}

// 安全にイベントを登録（要素がない環境でもエラーにしない）
if (menuButton && menuContactWrap) {
  menuButton.addEventListener("click", toggleMenu);
}
